import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { auth } from '../../config/firebase'
import {
  selectIsAuthenticated,
  selectAuthUser,
  setAuth,
  selectUserProfile,
} from '../../store/slices/userSlice'
import { initialiseUser, updateUserProfile } from '../db'

const useAuthListener = () => {
  const dispatch = useDispatch()

  const user = useSelector(selectAuthUser)
  const userProfile = useSelector(selectUserProfile)
  const isAuthenticated = useSelector(selectIsAuthenticated)

  useEffect(() => {
    return auth.onIdTokenChanged(async (user) => {
      if (user) {
        dispatch(
          setAuth({
            id: user.uid,
            email: user.email || '',
            emailVerified: user.emailVerified,
          }),
        )
      } else {
        dispatch(setAuth(null))
      }
    })
  }, [dispatch])

  useEffect(() => {
    if (user && isAuthenticated && !userProfile) {
      initialiseUser({
        userId: user.id,
        email: user.email || '',
        name: user.displayName,
      }).catch((err) => {
        console.log(err)
      })
    }
  }, [user, isAuthenticated, userProfile])

  useEffect(() => {
    if (user && user.emailVerified && !!userProfile) {
      updateUserProfile({
        userId: user.id,
        updates: {
          emailVerified: true,
        },
      })
    }
  }, [user, userProfile])
}

export const AuthListener = () => {
  useAuthListener()
  return null
}
